import { useEffect } from "react";
import { useSelector } from "react-redux";
import throttle from "modules/throttle";
import { useAppDispatch } from "store/hooks";
import { onSnapshot, QuerySnapshot, DocumentData } from "firebase/firestore";
import { selectCurrentEventId } from "modules/event/selectors";
import { setEventUsers } from "modules/eventUserPresence/redux/reducer";
import { getEventUserSessionsRef } from "modules/liveUserSessions/firestore";

const LIVE_USER_UPDATE_THROTTLE_TIME = 500;

export const LiveUserSessionsSubscriber = (): null => {
  const dispatch = useAppDispatch();
  const eventId = useSelector(selectCurrentEventId);

  const throttledDispatch = throttle(
    (snapshot: QuerySnapshot<DocumentData>) => {
      const eventUsers = snapshot.docs.map((doc) => {
        const data = doc.data();
        return {
          userId: data.userId as string,
          spaceId: data.spaceId as string,
        };
      });

      dispatch(setEventUsers(eventUsers));
    },
    LIVE_USER_UPDATE_THROTTLE_TIME,
  );

  useEffect(() => {
    if (!eventId) return undefined;

    const unsubscribe = onSnapshot(
      getEventUserSessionsRef(eventId),
      (snapshot) => {
        throttledDispatch(snapshot);
      },
    );

    return unsubscribe;
  }, [eventId, throttledDispatch]);

  return null;
};
